
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/events",
      function () {
        return require("private-next-pages/home/events/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/events"])
      });
    }
  